<template>
  <div>
    <v-container>
      <h3>Tax Details</h3>
      <v-data-table
        :headers="headers"
        :items-per-page="-1"
        :items="editedItem"
        dense
        hide-default-footer
        class="elevation-1"
      >
        <template v-slot:top>
          <div class="d-flex justify-end">
            <v-btn
              class="mx-2 recon-details-add-new-item"
              color="primary" fab icon x-small
              @click="addOne"
            >
              <v-icon>
                {{icons.mdiPlus}}
              </v-icon>
          </v-btn>
          </div>
        </template>
        <template v-slot:[`item.paymentInstallment`]="{ item }">
          <v-select
            label="Pmt Installment"
            v-model="item.paymentInstallment"
            :items="paymentInstallmentTypes"
            item-text="description"
            item-value="name"
          ></v-select>
        </template>
        <template v-slot:[`item.taxYear`]="{ item }">
          <v-text-field
            v-model.number="item.taxYear"
            label="Tax Year"
            @blur="somethingChanged"
          ></v-text-field>
        </template>
        <template v-slot:[`item.taxId`]="{ item }">
          <v-text-field
            label="Tax Id"
            v-model="item.taxId"
            @blur="somethingChanged"
          ></v-text-field>
        </template>
        <template v-slot:[`item.taxAmount`]="{ item }">
          <v-text-field
            label="Tax Amount"
            v-model="item.taxAmount"
            @blur="somethingChanged"
          ></v-text-field>
        </template>
        <template v-slot:[`item.penalty`]="{ item }">
          <v-text-field
            label="Penalty"
            v-model="item.penalty"
            @blur="somethingChanged"
          ></v-text-field>
        </template>
        <template v-slot:[`item.feeTotal`]="{ item }">
          <v-text-field
            label="Fee Total"
            v-model="item.feeTotal"
            @blur="somethingChanged"
          ></v-text-field>
        </template>
        <template v-slot:[`item.total`]="{ item }">
          <v-text-field
            label="Total"
            v-model="item.total"
            @blur="somethingChanged"
          ></v-text-field>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import {
  mapState,
} from 'vuex';
import {
  mdiPlus,
  // mdiDelete,
} from '@mdi/js';
import { amountFormat, amountToNumber } from '../../../../util/shared/vue-global';

const defaultItem = {
  paymentInstallment: null,
  taxAmount: 0.00,
  taxId: null,
  taxYear: null,
  penalty: 0.00,
  feeTotal: 0.00,
  total: 0.00,
};

export default {
  name: 'TaxDetails',
  created() {
  },
  props: {
    baseCrudKey: {
      type: String,
      default: 'ccPymentDetails-dialog',
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    icons: {
      mdiPlus,
      // mdiDelete,
    },
    headers: [
      { text: 'Payment Installment Type', value: 'paymentInstallment' },
      { text: 'Tax Year', value: 'taxYear' },
      { text: 'Tax Id', value: 'taxId' },
      { text: 'Tax Amount', value: 'taxAmount' },
      { text: 'Penalty', value: 'penalty' },
      { text: 'Fee Total', value: 'feeTotal' },
      { text: 'Total', value: 'total' },
      { text: 'Actions', value: 'actions', sortable: false },
    ],
  }),
  computed: {
    ...mapState({
      paymentInstallmentTypes: (state) => state.enums.TaxCCPaymentInstallmentEnum || [],
    }),
    editedItem: {
      get() {
        const newVal = JSON.parse(JSON.stringify(this.value));
        const updatedValue = newVal.map(this.loadInitialValues);
        return updatedValue;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    addOne() {
      this.$emit('input', [
        ...this.editedItem,
        {
          ...defaultItem,
        },
      ]);
      return true;
    },
    loadInitialValues(item) {
      return {
        ...item,
        taxAmount: amountFormat(amountToNumber(item.taxAmount)),
        penalty: amountFormat(amountToNumber(item.penalty)),
        feeTotal: amountFormat(amountToNumber(item.feeTotal)),
        total: amountFormat(amountToNumber(item.total)),
      };
    },
    somethingChanged() {
      this.$emit('input', this.editedItem);
    },
  },
};
</script>

<style lang="sass">
  .v-input.v-text-field
    padding-top: 0
    margin-top: 0
</style>
